import { z } from 'zod';

export const NOTIFICATION_TYPE_KEYS = [
    'new_event',
    'event_updated',
    'new_blog_post',
    'blog_comment_reply',
    'event_comment_reply',
    'reservation_updated',
    'new_rundbrief',
] as const;

export type NotificationTypeKey = (typeof NOTIFICATION_TYPE_KEYS)[number];

export const notificationPreferencesSchema = z.object({
    inapp_new_event: z.boolean(),
    inapp_event_updated: z.boolean(),
    inapp_new_blog_post: z.boolean(),
    inapp_blog_comment_reply: z.boolean(),
    inapp_event_comment_reply: z.boolean(),
    inapp_reservation_updated: z.boolean(),
    inapp_new_rundbrief: z.boolean(),
    push_new_event: z.boolean(),
    push_event_updated: z.boolean(),
    push_new_blog_post: z.boolean(),
    push_blog_comment_reply: z.boolean(),
    push_event_comment_reply: z.boolean(),
    push_reservation_updated: z.boolean(),
    push_new_rundbrief: z.boolean(),
    email_new_event: z.boolean(),
    email_event_updated: z.boolean(),
    email_new_blog_post: z.boolean(),
    email_blog_comment_reply: z.boolean(),
    email_event_comment_reply: z.boolean(),
    email_reservation_updated: z.boolean(),
    email_new_rundbrief: z.boolean(),
    types: z.array(z.object({ key: z.string(), label: z.string() })).optional(),
});

export type INotificationPreferences = z.infer<typeof notificationPreferencesSchema>;
